module.exports = __webpack_public_path__ + "static/media/headerWithoutImageLeftGraphic.17d59a99.svg";